export const BrandLS = () => (
    <div className="LStudio__app_container_loopy_strip" aria-label="Powered by Loopy Studios">
        <div className="LStudio__app_container_powered_by_container">
            <span className="LStudio__app_content_powered_text">Powered by</span>{" "}
            <a
                href="https://loopy-studios.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="LStudio__app_content_loopy_brand_link_glow"
            >
                <span className="tech-text-bold">Loopy Studios</span>
            </a>
        </div>
    </div>
);
